import React from 'react';
import { Modal } from '@mantine/core';
import { CIBUS_DIRECTION_LABELS, CIBUS_KIND_LABELS, CIBUS_STATUS_LABELS } from '../monitoring-page.constants';
import { formatDateTime } from '../monitoring-page.utils';
import type { UseMonitoringPage } from '../useMonitoringPage';
import classes from '../monitoring-page.module.scss';

type CibusCallLogDetailModalProps = Pick<UseMonitoringPage, 'selectedCibusLog' | 'closeCibusDetail'>;

const prettyJson = (value: string | null): string => {
  if (!value) {
    return '—';
  }
  try {
    return JSON.stringify(JSON.parse(value), null, 2);
  } catch {
    return value;
  }
};

export const CibusCallLogDetailModal: React.FC<CibusCallLogDetailModalProps> = ({
  selectedCibusLog,
  closeCibusDetail,
}) => {
  const row = selectedCibusLog;

  const fields: { label: string; value: string }[] = row
    ? [
        { label: 'תאריך ושעה', value: formatDateTime(row.createdAt) },
        { label: 'עסק', value: row.companyName ?? row.tenantId ?? '-' },
        { label: 'כיוון', value: CIBUS_DIRECTION_LABELS[row.direction] ?? row.direction },
        { label: 'סוג', value: CIBUS_KIND_LABELS[row.kind] ?? row.kind },
        { label: 'סטטוס', value: CIBUS_STATUS_LABELS[row.status] ?? row.status },
        { label: 'קוד HTTP', value: row.httpStatus != null ? String(row.httpStatus) : '-' },
        { label: 'זמן תגובה', value: row.latencyMs != null ? `${row.latencyMs} ms` : '-' },
        { label: 'מזהה בקשה', value: row.requestId ?? '-' },
      ]
    : [];

  return (
    <Modal
      opened={row != null}
      onClose={closeCibusDetail}
      title={row ? `${CIBUS_KIND_LABELS[row.kind] ?? row.kind} · ${CIBUS_STATUS_LABELS[row.status] ?? row.status}` : ''}
      centered
      size="xl"
      closeButtonProps={{ 'data-testid': 'monitoring-cibus-detail-close' } as Record<string, string>}
    >
      {row && (
        <div className={classes.errorDetail} data-testid="monitoring-cibus-detail">
          <div className={classes.detailsSection}>
            {fields.map((field) => (
              <div key={field.label} className={classes.detailField}>
                <span className={classes.detailLabel}>{field.label}</span>
                <span className={classes.detailValue}>{field.value}</span>
              </div>
            ))}
          </div>

          {row.errorMessage && (
            <>
              <div className={classes.sectionTitle}>{'שגיאה'}</div>
              <pre className={classes.errorTrace}>{row.errorMessage}</pre>
            </>
          )}

          <div className={classes.sectionTitle}>{'בקשה'}</div>
          <pre className={classes.errorTrace}>{prettyJson(row.requestPayload)}</pre>

          <div className={classes.sectionTitle}>{'תגובה'}</div>
          <pre className={classes.errorTrace}>{prettyJson(row.responseBody)}</pre>
        </div>
      )}
    </Modal>
  );
};
